export const cardType = {
  AX: 'American Express',
  CA: 'MasterCard',
  VI: 'Visa',
  DS: 'Discover',
  DC: 'Diners Club',
};
